import { httpClient } from '@/services/http/httpClient'

import type { User } from '@/services/http/usersService/types'

export type UpdateCurrentUserParams = {
  email?: string
  name?: string
  area?: string
  profilePhoto?: null
}

export async function updateCurrentUser({
  email,
  name,
  area,
  profilePhoto,
}: UpdateCurrentUserParams): Promise<{ user: User }> {
  const response = await httpClient.put(`/users/me`, {
    email,
    name,
    areaId: area,
    ...(profilePhoto === null ? { image: null } : {}),
  })

  return response.data
}
